import { TOGGLE_NAVBAR_SECTION } from "./navBarReducer"

export const toggleSectionDrawer = (key, value) => ({
    type: TOGGLE_NAVBAR_SECTION,
    payload: {
        key: key,
        value: value
    }
})